import type { FC, ReactNode } from "react";
import type { ViewProps } from "../View";
import { View } from "../View";
import { ModeSwitcher } from "../ModeSwitcher";
import { Edit } from "../Edit";

type Props = {
  data: ViewProps[];
  editNode: (index: number) => ReactNode;
  isEdit: boolean;
  onTrashClick: (index: number) => void;
};

export const List: FC<Props> = ({ data, editNode, isEdit, onTrashClick }) => {
  return (
    <>
      {data?.map((item, index) => {
        return (
          <ModeSwitcher
            key={item.id}
            editNode={<Edit onTrashClick={() => onTrashClick(index)}>{editNode(index)}</Edit>}
            isEdit={isEdit}
            viewNode={<View {...item} />}
          />
        );
      })}
    </>
  );
};
